import React from "react";
import styled, { css } from "styled-components";
import { useMeasure } from "react-use";

const headerBorderPadding = 8;

const ManageRepaymentsButtonContainerWrapper = styled.div(({ theme }) => css`
  @media only screen and (max-width: 766px) {
    margin-top: 0 !important;
  }
  
  .header {
    font-size: 22px;
    padding: ${headerBorderPadding}px 0;
    border-top: 1px solid #888;
    border-bottom: 1px solid #888;
    margin-bottom: 24px;

    @media only screen and (min-width: ${theme.breakpoints.M}) {
      border-top: none;
    }
  }
`);

export const ManageRepaymentsButtonContainer = ({ children }) => {
  const [ref, {height}] = useMeasure();
  const heightOfElement = height + (headerBorderPadding * 2);

  return (
    <ManageRepaymentsButtonContainerWrapper style={{marginTop: `-${heightOfElement}px`}}>
      <h3 className="header" ref={ref}>What would you like to do?</h3>
      {children}
    </ManageRepaymentsButtonContainerWrapper>
  );
}